export const ERROR_CS =
  '카카오 플러스 친구 [베이비페이스 고객센터]에 문의 해주세요.';
export const ERROR_RETRY = `잠시 후에 다시 시도해주세요.\n오류가 계속되면, ${ERROR_CS}`;

export const ERROR_VALIDATE = {
  email: '잘못된 이메일 형식입니다.',
  password:
    '비밀번호는 특수문자, 영문 대/소문자, 숫자를 2개 이상 조합하여 6~15자 이내로 입력해주세요.',
  passwordConfirm: '비밀번호확인이 일치하지 않습니다.',
  name: '이름은 1자이상 100자 이하입니다.',
  mobile: '전화번호는 -를 제외한 숫자 10~11자입니다.',
};

export const ERROR_VALIDATE_ORDER = {
  mobile: '전화번호는 -를 제외한 숫자 10~11자입니다.',
  detailAddress: '주소(상세주소 포함)를 입력해주세요.',
  name: '이름은 2~10자만 입력 가능합니다.',
  ultrasound: '초음파 사진을 올려주세요.',
  messageToBaby: '아기에게 보내는 메시지는 최대 20자까지 작성하실 수 있습니다.',
};

export const ERROR_LOGIN =
  '로그인이 필요한 서비스 입니다. 로그인 페이지로 이동합니다.';

export const ERROR_REFRESH = `새로고침 후 다시 이용해주세요.\n오류가 계속되면, ${ERROR_CS}`;

export const STATUS_MESSAGE = {
  voucher: {
    200: '쿠폰이 다운로드 되었습니다.\n발급받으신 쿠폰은 쿠폰함에서 확인 가능합니다.',
    404: '존재하지 않는 코드입니다. 코드를 다시 입력해주세요.',
    409: '이미 발급 받으신 쿠폰입니다.\n발급받으신 쿠폰은 쿠폰함에서 확인 가능합니다.',
    500: `유효하지 않은 상품권/쿠폰 입니다. ${ERROR_CS}`,
    prePurchase: {
      success:
        '구매하신 사전 구매쿠폰이 쿠폰함에 자동 등록되었습니다. \n등록된 사전 구매쿠폰은 쿠폰함에서 확인 가능합니다',
      error:
        '구매하신 사전 구매쿠폰이 자동 등록에 실패했습니다. \n사전 구매쿠폰 코드 번호는 주문내역에서 확인 가능하며 쿠폰함에서 등록 가능합니다.',
    },
  },
  order: {
    testPrice: {
      409: '이 쿠폰은 다른 쿠폰과 중복 사용이 불가능합니다.',
    },
    refund: {
      REQUIRE_VALIDATION: '환불정보를 확인해주세요',
      200: '예금주가 일치하지 않습니다.',
    },
    requestPay: {
      FAIL: '결제에 실패하였습니다.',
    },
    409: { ALREADY_EXISTS: '본인한테 선물을 보낼 수 없습니다' },
    500: {
      optionId:
        '선택하신 상품권(스튜디오/사진관 등)은 빠른 분석 (24시간) 옵션 선택이 불가능합니다. 일반 분석 (3일)으로 신청해주세요.',
      ERR:
        '선물 받은 상품권과 신청한 옵션이 다릅니다. 선물 받은 상품권의 옵션을 확인해주세요.',
    },
    validate: ERROR_VALIDATE_ORDER,
    babyUpload: '초음파 사진을 올리는데 실패했습니다.',
    present: {
      REQUIRE_VALIDATION: '필수값을 입력하세요',
      NO_EMOGI: '메시지에 이모지가 섞일 수 없습니다.',
    },
    voucherOrderTemplate: {
      404: `해당되는 상품/옵션을 찾을 수 없습니다. ${ERROR_CS}`,
    },
  },
  login: {
    401: {
      AUTH_NO_USER: '이메일 주소를 확인해주세요.',
      AUTH_PASSWORD_MISSMATCH: '비밀번호를 확인해주세요.',
    },
  },
  signUp: {
    200: '회원가입에 성공했습니다.',
    400: ERROR_VALIDATE,
    409: '이미 존재하는 이메일 입니다.',
  },
  user: {
    findInfo: {
      404: '일치하는 회원정보가 없습니다. \n네이버로그인 회원가입 사용자일 경우 네이버로그인 해주세요.',
    },
    changeMobile: {
      200: '휴대폰번호 수정이 완료되었습니다',
      409: '이미 가입된 휴대폰번호입니다.',
    },
    changePassword: {
      200: '비밀번호 변경이 완료되었습니다',
      400: ERROR_VALIDATE.password,
      401: '현재 비밀번호가 일치하지 않습니다.',
      409: '새로운 비밀번호와 현재 비밀번호가 동일합니다.',
    },
    withDrawal: {
      200: ['베이비페이스 탈퇴가 완료되었습니다.', '이용해 주셔서 감사합니다'],
      404: '이미 탈퇴한 회원입니다.',
    },
    validateMobileCode: {
      TIMEOVER: '인증시간이 초과되었습니다.',
      INVALID_CODE: '잘못된 코드입니다.',
      REQUIRE_VALIDATION: '휴대폰을 인증해주세요.',
      SAME_CODE: '이전 휴대폰번호와 같습니다.',
    },
  },
  completion: {
    ULTRASOUND:
      '초음파 사진 업로드중 오류가 발생하였습니다. "주문상세"에서 초음파 사진을 추가해주세요',
  },
};
